import { Injectable } from '@angular/core';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { CostCenterFindInterface } from '@zaoblako/shared/modules/catalog/dtos/cost-center/cost-center-find.dto';
import type { CostCenterPageInterface } from '@zaoblako/shared/modules/catalog/dtos/cost-center/cost-center-page.dto';
import type { CostCenterQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/cost-center/cost-center-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisCostCenterService extends BaseService {
  protected baseUrl = '/basis/catalog/cost-center';

  public get dropdownDescriptorApi(): string {
    return `${this.baseUrl}/dropdown-descriptor`;
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: CostCenterQueryInterface): Observable<CostCenterPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<CostCenterPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public restore(id: number): Observable<CostCenterFindInterface> {
    return this.http.post<CostCenterFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getAllHistory(queryParams: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getHistory(id: number, options: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(options)
    });
  }

  public synchronize(): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/synchronize/1c`, null);
  }
}
